import templateUrl from './bulletin-list.component.html'
import { EditBulletinModal } from './edit-bulletin.component';

export const BulletinListComponent = {
    controller: BulletinListController,
    controllerAs: "vm",
    templateUrl
}

function BulletinListController($uibModal, utilityService, messageService) {
    'ngInject'
    const vm = this;

    vm.bulletins = [];

    vm.addNewBulletin = addNewBulletin;
    vm.editBulletin = editBulletin;
    vm.deliverBulkEmails = deliverBulkEmails;

    vm.$onInit = $onInit;

    function $onInit() {
        loadBulletins();
    }

    function loadBulletins() {
        utilityService.showLoading();
        return messageService.retrieveBulletins()
            .then(function (bulletins) {
                vm.bulletins = bulletins;
            })
            .catch(function (ex) {
                alert("Initial load failed: " + (ex.statusText || ex));
            })
            .then(function () {
                utilityService.hideLoading();
            });
    }

    function addNewBulletin() {
        showEditForm();
    }

    function editBulletin(bulletin) {
        showEditForm(bulletin.BulletinID);
    }

    function showEditForm(bulletinID) {
        return $uibModal.open({
            ...EditBulletinModal,
            resolve: {
                bulletinID: () => bulletinID
            }
        })
            .result
            .then(function (item) {
                // On close, reload the bulletin list.
                return loadBulletins();
            });
    }

    function deliverBulkEmails(bulletin) {
        if (!confirm("All recipients on this bulletin will be sent an email. This will count as an acknowledgment on their end and the message will not show under the bulletin inbox. Continue?")) {
            return;
        }
        utilityService.showLoading();
        messageService.deliverEmails(bulletin.BulletinID)
            .then(function () {
                alert("Messages have been queued for sending.");
            })
            .catch(function (ex) {
                alert("Error: queueing messages for deliver failed. " + (ex.statusText !== undefined ? ex.statusText : ex.message !== undefined ? ex.message : ex));
            })
            .then(utilityService.hideLoading);
    }
}
